import React, { useEffect, useState } from "react";
import "./assets/css/TemplateDesign.css";
import { AiFillFileText, AiOutlineFileText } from "react-icons/ai";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";

const TextComponentLeft = (props) => {
  const [lock, setLock] = useState(props.custom_text_lock);
  const [transparency, setTransparency] = useState(props.transparency);
  const [text_autofit, setTextAutofit] = useState(props.text_autofit);

  useEffect(() => {
    setLock(props.custom_text_lock);
    setTransparency(props.transparency);
    setTextAutofit(props.text_autofit);
  }, [props.custom_text_lock, props.transparency, props.text_autofit]);

  const toggleLock = (e) => {
    setLock(!lock);
    props.handleLockUnlock(props.id, !lock, "custom_text_lock");
  };

  const toggleTransparency = (e) => {
    setTransparency(!transparency);
    props.handleTextTransparency(props.id, !transparency, "custom_text");
  };

  const toggleTextAutofit = (e) => {
    setTextAutofit(!text_autofit);
    props.handleTextFit(props.id, !text_autofit, "custom_text");
    setTimeout(() => {
      props.ParentSelectCustomText(props.id, "custom_text");
    }, 200);
  };

  return (
    <>
      <div className="custom_text_full font-family-inherit">
        <p
          dangerouslySetInnerHTML={{ __html: props.title }}
          onClick={() => props.ParentSelectCustomText(props.id, "custom_text")}
        ></p>
        <div className="text-btn-block">
          <button
            style={{ padding: "1px 8px", margin: "2px", fontSize: "16px", background: "transparent" }}
            value={text_autofit}
            onClick={(e) => toggleTextAutofit(e)}
          >
            {text_autofit ? (
              <BsToggleOn title={'Remove Text Fit'} />
            ) : (
              <BsToggleOff title={'Apply Text Fit'} />
            )}
          </button>
          <button
            style={{ padding: "1px 8px", margin: "2px", fontSize: "16px", background: "transparent" }}
            value={transparency}
            onClick={(e) => toggleTransparency(e)}
          >
            {transparency ? (
              <AiOutlineFileText title={'Remove Transparency'} />
            ) : (
              <AiFillFileText title={'Add Transparency'} />
            )}
          </button>
          <button
            style={{ padding: "1px 8px", margin: "2px", fontSize: "16px", background: "transparent" }}
            value={lock}
            onClick={(e) => toggleLock(e)}
          >
            {lock ? (
              <i style={{ color: "#66707d" }} className="fas fa-lock"></i>
            ) : (
              <i style={{ color: "#cccccc" }} className="fas fa-unlock"></i>
            )}
          </button>
          <button
            className="btn btn-delete"
            onClick={() => props.ParentDeleteCustomElement(props.id)}
          >
            Delete
          </button>
        </div>
      </div>
    </>
  );
};

export default TextComponentLeft;
